module.exports = __webpack_public_path__ + "static/media/preview.657b740e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/DogProfile/preview.svg
// module id = 343
// module chunks = 0